import { Grid, Typography } from '@mui/material'
import { StaticImageData } from 'next/image'

import { Author } from '@ecm/data/Author'
import AuthorPhoto from '@ecm/ui/component/blog/AuthorPhoto'
import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import useSmallScreen from '@ecm/ui/hook/UseSmallScreen'

type HeaderBlockProps = {
  author?: Author
  children?: React.ReactNode
  illustration: StaticImageData
}

const HeaderBlock = ({ author, children, illustration }: HeaderBlockProps) => {
  const isSmallScreen = useSmallScreen()
  return (
    <Grid
      display="grid"
      paddingY={{ md: '4em', xs: '2em' }}
      flexGrow={1}
      gridTemplateColumns={{
        md: '2fr 1fr',
        xs: '1fr',
      }}
    >
      <Grid
        container
        flexDirection={author ? 'row' : 'column'}
        alignItems={author ? 'center' : 'start'}
      >
        {author && author.photoUrl && (
          <AuthorPhoto big src={author.photoUrl} alt={author.fullname} />
        )}
        <Typography variant="h2" component="h1" my={{ md: '1em', xs: '0.3em' }}>
          {author ? author.fullname : 'Blog'}
        </Typography>
        {children}
      </Grid>
      {!isSmallScreen && <CloudflareImage src={illustration} />}
    </Grid>
  )
}

export default HeaderBlock
